"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWalletAccount = exports.isTaprootAddress = exports.isValidAddress = exports.Merge = exports.DeepFirst = exports.CoinSelect = exports.DerivationModes = exports.BitcoinLikeWallet = void 0;
const wallet_1 = __importDefault(require("./wallet"));
exports.BitcoinLikeWallet = wallet_1.default;
const types_1 = require("./types");
Object.defineProperty(exports, "DerivationModes", { enumerable: true, get: function () { return types_1.DerivationModes; } });
const CoinSelect_1 = require("./pickingstrategies/CoinSelect");
Object.defineProperty(exports, "CoinSelect", { enumerable: true, get: function () { return CoinSelect_1.CoinSelect; } });
const DeepFirst_1 = require("./pickingstrategies/DeepFirst");
Object.defineProperty(exports, "DeepFirst", { enumerable: true, get: function () { return DeepFirst_1.DeepFirst; } });
const Merge_1 = require("./pickingstrategies/Merge");
Object.defineProperty(exports, "Merge", { enumerable: true, get: function () { return Merge_1.Merge; } });
const utils_1 = require("./utils");
Object.defineProperty(exports, "isValidAddress", { enumerable: true, get: function () { return utils_1.isValidAddress; } });
Object.defineProperty(exports, "isTaprootAddress", { enumerable: true, get: function () { return utils_1.isTaprootAddress; } });
const errors_1 = require("../../../errors");
let wallet = null;
const getWalletAccount = (account) => {
    var _a;
    const walletAccount = (_a = account.bitcoinResources) === null || _a === void 0 ? void 0 : _a.walletAccount;
    if (account.id.startsWith("libcore") || !walletAccount) {
        throw new errors_1.AccountNeedResync();
    }
    return walletAccount;
};
exports.getWalletAccount = getWalletAccount;
const getWallet = () => {
    if (!wallet) {
        wallet = new wallet_1.default();
    }
    return wallet;
};
exports.default = getWallet();
//# sourceMappingURL=index.js.map